// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-robot-icon[data-v-706c6092]{width:24px;height:24px;color:inherit}", ""]);
// Exports
module.exports = exports;
